import { useApi } from '@repo/api'
import { useDbSessionQueryCollection } from '@repo/tanstack/db'

export const useLoadStatuses = () => {
  const api = useApi()
  const result = useDbSessionQueryCollection({
    getKey: row => row.id,
    id: 'load-statuses',
    queryFn: () => api.loads.getStatuses.query(),
    queryKey: api.loads.getStatuses.queryKey(),
    schemaVersion: 1,
  })

  return { ...result, data: result.data ?? [] }
}
